import React, { useState, useEffect, useRef } from "react";
import AdminHeader from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import { useForm } from "react-hook-form";
import { ApiService } from "../../component/Services/apiservices";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

function DefaultStrategy() {
    let apiServices = new ApiService();
    const [defaultstrategyid, setdefaultstrategyid] = useState(null);
    const didMountRef = useRef(true);
    const Navigate = useNavigate();
    
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    const onSubmit = (data) => {
        const datastring = {
            df_stra_budget: data.stra_budget,
            df_stra_lower_budget: data.stra_lower_budget,
            df_stra_upper_budget: data.stra_upper_budget,
            df_stra_equity_target: data.stra_equity_target,
            df_stra_equity_target_achieve: data.stra_equity_target_achieve,
            df_stra_annual_cashflow_target: data.stra_annual_cashflow_target,
            df_stra_cashflow_target_achieve: data.stra_cashflow_target_achieve,
            df_stra_risk_app: data.stra_risk_app,
            defaultstrategy_id: defaultstrategyid
        };

        // Note: Make sure to create this function in your ApiService
        apiServices.savedefaultstrategy(datastring).then(res => {
            if (res.data.status === "success") {
                toast.success(res?.data?.message || "Default Strategy saved successfully!");
            } else {
                toast.error(res?.data?.message || "Failed to save Default Strategy.");
            }
        }).catch(err => {
            toast.error("Something went wrong while saving.");
        });
    };

    useEffect(() => {
        if (didMountRef.current) {
            // Note: Make sure to create this function in your ApiService
            apiServices.getdefaultstrategyrequest().then(res => {
                if (res?.data?.status === "success") {
                    if (res?.data?.defaultstrategy !== null) {
                        const data = res?.data?.defaultstrategy;
                        setdefaultstrategyid(data?._id);
                        
                        setValue("stra_budget", data?.df_stra_budget);
                        setValue("stra_lower_budget", data?.df_stra_lower_budget);
                        setValue("stra_upper_budget", data?.df_stra_upper_budget);
                        setValue("stra_equity_target", data?.df_stra_equity_target);
                        setValue("stra_equity_target_achieve", data?.df_stra_equity_target_achieve);
                        setValue("stra_annual_cashflow_target", data?.df_stra_annual_cashflow_target);
                        setValue("stra_cashflow_target_achieve", data?.df_stra_cashflow_target_achieve);
                        setValue("stra_risk_app", data?.df_stra_risk_app);
                    }
                }
            }).catch(() => {});
        }
        didMountRef.current = false;
    }, [setValue]);

    return (
        <>
            <ToastContainer />
            <div id="layout-wrapper">

                <AdminHeader />
                <Sidebar />

                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">

                            {/* Page Title */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Default Strategy</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="/csadmin/dashboard">Dashboard</a></li>
                                                <li className="breadcrumb-item active">Default Strategy</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Main Form Content */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header align-items-center d-flex">
                                            <h4 className="card-title mb-0 flex-grow-1">Strategy Values</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="live-preview">
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    
                                                    <h6 className="mb-3 text-primary">Budget & Capacity</h6>
                                                    <div className="row gy-4 mb-4">
                                                        <div className="col-xxl-4 col-md-4">
                                                            <div>
                                                                <label htmlFor="stra_budget" className="form-label">Target Budget</label>
                                                                <input type="number" className="form-control" name="stra_budget" {...register("stra_budget", { required: true })} step="any" placeholder="e.g. 750000" />
                                                                {errors.stra_budget && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-4 col-md-4">
                                                            <div>
                                                                <label htmlFor="stra_lower_budget" className="form-label">Lower Budget Limit</label>
                                                                <input type="number" className="form-control" name="stra_lower_budget" {...register("stra_lower_budget", { required: true })} step="any" placeholder="e.g. 600000" />
                                                                {errors.stra_lower_budget && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-4 col-md-4">
                                                            <div>
                                                                <label htmlFor="stra_upper_budget" className="form-label">Upper Budget Limit</label>
                                                                <input type="number" className="form-control" name="stra_upper_budget" {...register("stra_upper_budget", { required: true })} step="any" placeholder="e.g. 900000" />
                                                                {errors.stra_upper_budget && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className="my-4 border-secondary opacity-25" />
                                                    <h6 className="mb-3 text-primary">Financial Targets</h6>
                                                    
                                                    <div className="row gy-4 mb-4">
                                                        <div className="col-xxl-3 col-md-6">
                                                            <div>
                                                                <label htmlFor="stra_equity_target" className="form-label">Equity Target ($)</label>
                                                                <input type="number" className="form-control" name="stra_equity_target" {...register("stra_equity_target", { required: true })} step="any" placeholder="e.g. 200000" />
                                                                {errors.stra_equity_target && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-3 col-md-6">
                                                            <div>
                                                                <label htmlFor="stra_equity_target_achieve" className="form-label">Equity Target Years</label>
                                                                <input type="number" className="form-control" name="stra_equity_target_achieve" {...register("stra_equity_target_achieve", { required: true })} step="any" placeholder="e.g. 5" />
                                                                {errors.stra_equity_target_achieve && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-3 col-md-6">
                                                            <div>
                                                                <label htmlFor="stra_annual_cashflow_target" className="form-label">Annual Cashflow Target ($)</label>
                                                                <input type="number" className="form-control" name="stra_annual_cashflow_target" {...register("stra_annual_cashflow_target", { required: true })} step="any" placeholder="e.g. 10000" />
                                                                {errors.stra_annual_cashflow_target && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-3 col-md-6">
                                                            <div>
                                                                <label htmlFor="stra_cashflow_target_achieve" className="form-label">Cashflow Target Years</label>
                                                                <input type="number" className="form-control" name="stra_cashflow_target_achieve" {...register("stra_cashflow_target_achieve", { required: true })} step="any" placeholder="e.g. 3" />
                                                                {errors.stra_cashflow_target_achieve && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className="my-4 border-secondary opacity-25" />
                                                    <h6 className="mb-3 text-primary">Risk Profile</h6>

                                                    <div className="row gy-4 mb-4">
                                                        <div className="col-xxl-4 col-md-6">
                                                            <div>
                                                                <label htmlFor="stra_risk_app" className="form-label">Risk Appetite</label>
                                                                <select className="form-select form-control" name="stra_risk_app" {...register("stra_risk_app", { required: true })}>
                                                                    <option value="">Select Risk</option>
                                                                    <option value="low">Low Risk</option>
                                                                    <option value="medium">Medium Risk</option>
                                                                    <option value="high">High Risk</option>
                                                                </select>
                                                                {errors.stra_risk_app && <span className="text-danger small">Required</span>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Submit Button */}
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="text-end mt-4">
                                                                <button type="submit" className="btn btn-primary px-4 shadow-sm">Save Default Strategy</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default DefaultStrategy;